import React, { Component } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import '../screen.css';

function withNavigation(ComponentWithNav) {
  return function WrappedComponent(props) {
    const navigate = useNavigate();
    return <ComponentWithNav {...props} navigate={navigate} />;
  };
}

class AccessDenied extends Component {
  handleGoBack = () => {
    this.props.navigate('/dashboard');
  };

  render() {
    return (
      <div className="access-denied-container">
        <img src="img/access-denied-icon.png" alt="Access Denied" width={160} />
        <h1 className="access-denied-title">Access Denied</h1>
        <p className="access-denied-message">You do not have permission to view this page.</p>
        <button className="access-denied-button" onClick={this.handleGoBack}>
          Go to Dashboard
        </button>
      </div>
    );
  }
}

export default withNavigation(AccessDenied);
